import { GET_ORDER_PROCESSING } from './ApiConstants';
import api from './ApiHandler';

export const getOrderProcessingByPage = async (payload: any) => {
  return await api.get(GET_ORDER_PROCESSING, { params: payload });
};

export const getOrderProcessing = async ({ id }: { id: string }) => {
  return await api.get(GET_ORDER_PROCESSING, { params: { id } });
};
